module.exports = __webpack_public_path__ + "media/images/brand/newsletter/mail_man_800-c52d15456072f592b7cb5e49fa4c81d0.png";